module.exports = __webpack_public_path__ + "static/media/budget-shot.4b9438a9.PNG";